import {
    IUpdateDisplay
} from '../actions/toggle-alert-banner-display';
import { IBillingState } from '../state';

export const toggleAlertDisplay =
    (state: IBillingState, action: IUpdateDisplay) => {
        return {
            ...state,
            showBanner: action.data
        }
    };
